"use client";

import React from "react";

//Types
import { ListProps } from "@/types";

//Styled
import * as S from "./styles";

const List: React.FC<ListProps> = ({ itemList }) => {
  return (
    <S.List>
      {itemList.map((item: string, index: number) => (
        <S.ListItem key={index}>{item}</S.ListItem>
      ))}
    </S.List>
  );
};

export default List;
